module.exports = __webpack_public_path__ + "static/sca2-0a587cf27f7b231302f6d44f71cfba5d.png";